module.exports = __webpack_public_path__ + "static/media/iu_logo.b02b5929.png";